export class IsEditForm {
    public static readonly type = "[Forms] Load is edit";

    constructor(public payload: boolean) {}
}
